const PRIORITY_VARIANT_ID = 50153120661741;
const READY_TO_GIFT_VARIANT_ID = 49931492884717;

function showPriorityNotice(message) {
  let noticeBox = document.querySelector('.priority-fulfillment-inline-notice');

  if (!noticeBox) {
    noticeBox = document.createElement('div');
    noticeBox.className = 'priority-fulfillment-inline-notice';

    const checkboxBox = document.querySelector('.priority-fulfillment-box');
    if (checkboxBox) {
      checkboxBox.insertAdjacentElement('afterend', noticeBox);
    } else {
      document.body.prepend(noticeBox);
    }
  }

  noticeBox.innerHTML = '<strong>Notice:</strong> ' + message;
}

async function updatePriorityCheckboxState() {
  const checkbox = document.getElementById('PriorityFulfillmentCheckbox');
  const message = document.getElementById('PriorityFulfillmentMessage');

  if (!checkbox) return;

  const cartResponse = await fetch('/cart.js');
  const cart = await cartResponse.json();

  const hasPriorityAlready = cart.items.some(function (item) {
    return Number(item.variant_id) === Number(PRIORITY_VARIANT_ID);
  });

  const hasReadyToGiftAlready = cart.items.some(function (item) {
    return Number(item.variant_id) === Number(READY_TO_GIFT_VARIANT_ID);
  });

  if (hasPriorityAlready) {
    checkbox.checked = true;
    checkbox.disabled = true;

    if (message) {
      message.style.display = 'block';
      message.style.color = '#2e7d32';
      message.innerHTML = '✓ Priority Fulfillment already added for this order.';
    }

    return;
  }

  if (hasReadyToGiftAlready) {
    checkbox.checked = false;
    checkbox.disabled = true;

    if (message) {
      message.style.display = 'block';
      message.style.color = '#b00020';
      message.innerHTML = 'Priority Fulfillment is not available while Ready to Gift Wrapping is in your cart.';
    }
  }
}

document.addEventListener(
  'submit',
  async function (event) {
    const form = event.target;

    if (!form || !form.querySelector('input[name="id"]')) return;

    const checkbox = document.getElementById('PriorityFulfillmentCheckbox');
    const eligibleInput = form.querySelector('input[name="properties[_priority_eligible]"]');

    if (!checkbox || !checkbox.checked || !eligibleInput) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const cartResponse = await fetch('/cart.js');
    const currentCart = await cartResponse.json();

    const hasPriorityAlready = currentCart.items.some(function (item) {
      return Number(item.variant_id) === Number(PRIORITY_VARIANT_ID);
    });

    const hasReadyToGiftAlready = currentCart.items.some(function (item) {
      return Number(item.variant_id) === Number(READY_TO_GIFT_VARIANT_ID);
    });

    if (hasReadyToGiftAlready) {
      showPriorityNotice(
        'Priority Fulfillment is not available while Ready to Gift Wrapping is in your cart. Remove Ready to Gift Wrapping if you would like your books fulfilled through Amazon instead.'
      );
      return;
    }

    const formData = new FormData(form);
    const bookVariantId = Number(formData.get('id'));
    const quantity = Number(formData.get('quantity') || 1);

    const itemsToAdd = [
      {
        id: bookVariantId,
        quantity: quantity,
        properties: {
          _priority_eligible: 'true'
        }
      }
    ];

    if (!hasPriorityAlready) {
      itemsToAdd.push({
        id: PRIORITY_VARIANT_ID,
        quantity: 1,
        properties: {
          _priority_fulfillment: 'true'
        }
      });
    }

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: itemsToAdd
      })
    });

    window.location.href = '/cart';
  },
  true
);

async function removePriorityIfNoBooksRemain() {
  const response = await fetch('/cart.js');
  const cart = await response.json();

  const priorityItem = cart.items.find(function (item) {
    return Number(item.variant_id) === Number(PRIORITY_VARIANT_ID);
  });

  const hasEligibleBook = cart.items.some(function (item) {
    return (
      Number(item.variant_id) !== Number(PRIORITY_VARIANT_ID) &&
      item.properties &&
      item.properties._priority_eligible === 'true'
    );
  });

  const hasReadyToGift = cart.items.some(function (item) {
    return Number(item.variant_id) === Number(READY_TO_GIFT_VARIANT_ID);
  });

  if (priorityItem && hasReadyToGift) {
    sessionStorage.setItem(
      'priorityNotice',
      'Priority Fulfillment was removed because Ready to Gift Wrapping requires your books to be shipped from L.K. Bunting so they can be wrapped before being sent to you.'
    );

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: priorityItem.key,
        quantity: 0
      })
    });

    window.location.reload();
    return;
  }

  if (priorityItem && !hasEligibleBook) {
    sessionStorage.setItem(
      'priorityNotice',
      'Priority Fulfillment was removed because there are no personalized books, non-personalized journals, or storybooks remaining in your cart.'
    );

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: priorityItem.key,
        quantity: 0
      })
    });

    window.location.reload();
  }
}

document.addEventListener('DOMContentLoaded', function () {
  updatePriorityCheckboxState();
  removePriorityIfNoBooksRemain();
});